import React from 'react'
import styled from 'styled-components'
import Navbar from '../components/Navbar'

const ResetPage = () => {
    return (
        <div>
            <Navbar />
            <ContentBox>
                ResetPage
            </ContentBox>
        </div>
    )
}

export default ResetPage

const ContentBox = styled.div`
  width: 98%;
  margin-top: 70px;
  z-index: -10000000;


`